var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSighupUserStyleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.14 10.726a3 3 0 0 0-4.656-3.784L13.228 22.027l-6.482-6.482a3 3 0 1 0-4.242 4.242l8.772 8.773a3 3 0 0 0 4.51-.167l14.355-17.667z",
    fill: "#FBED7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSighupUserStyleCheck);
export default __webpack_public_path__ + "static/media/sighup_user_style_check.7cf4a9971b3cdb04aba9d3d57ca22c46.svg";
export { ForwardRef as ReactComponent };